import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  statusUpdater,
  getDescriptors,
} from "wvus-sponsorship-engine";

class ChildDescriptors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      descriptorIndex: null,
    };
  }

  render() {
      return <span>{this.props.descriptors[this.props.descriptorIndex]}</span>;
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

// Get actions and pass them as props to to UserList
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      statusUpdater: statusUpdater,
      getDescriptors: getDescriptors,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ChildDescriptors);
